const SubmitButton = require('../submit_button');
const { store: ShippingLabelStore } = require('../shipping_label_form_module');
const { mapStateToProps } = require('@reverbdotcom/discovery-ui');

function mapper() {
  const { insurancePolicy, shipment } = ShippingLabelStore.getState();

  let disableSubmit = false;
  if (insurancePolicy && shipment) {
    disableSubmit = shipment.needsCustoms && insurancePolicy.aboveMaximumIntlDeclaredValueThreshold;
  }

  return {
    disableSubmit,
  };
}

module.exports = mapStateToProps({
  mapper, stores: [ShippingLabelStore],
})(SubmitButton, 'SubmitButton');



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/containers/submit_button_container.jsx